import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const eventConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EVENTS_BY_RECON_SUCCESS:
            return {
                ...state,
                eventsByRecons: action.payload,
                eventNamesForJSON: _map(action.payload, (item) => ({
                    label: item.name,
                    value: item.name,
                    event_ref_id: item.ref_id,
                })),
            };

        default:
            return state;
    }
};

export default eventConfigurationReducer;
